module.exports = __webpack_public_path__ + "static/tat-21-5f835357c5612bd890852506c2e3f564.jpg";